module.exports = __webpack_public_path__ + "img/work_from_anywhere2.4269e660.png";